var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"how-to-play__title"},[_c('h1',[_vm._v(_vm._s(_vm.getTranslatedText("How to play")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }